import { useCallback, useEffect, useState } from 'react';
import { apiClient } from '../api/client';
import { logger } from './logger';

/** 🚫 Kapalı coinler — tüm botlar için tek liste (normal bot + hızlı bot). */
export function useCoinsOff() {
    const [items, setItems] = useState([]);
    const [busy, setBusy] = useState(false);

    const load = useCallback(async () => {
        try {
            const { data } = await apiClient.get('/coins-off');
            setItems(data.items || []);
        } catch (e) {
            logger.warn('coins-off load failed', e);
        }
    }, []);

    useEffect(() => { load(); }, [load]);

    const toggle = useCallback(async (symbol) => {
        setBusy(true);
        try {
            const off = items.some((i) => i.symbol === symbol);
            if (off) await apiClient.delete(`/coins-off/${symbol}`);
            else await apiClient.post(`/coins-off/${symbol}`, {});
            await load();
            return !off;
        } finally {
            setBusy(false);
        }
    }, [items, load]);

    const offSet = new Set(items.map((i) => i.symbol));
    return { items, offSet, busy, toggle, reload: load };
}
